import React, { useState, useCallback, Fragment, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "../../images/logo/hrb-logo.png";
import LogoWhite from "../../images/logo/logofull-white.png";
import bg6 from "../../images/background/bg6.jpg";
import FloatingSupport from "../components/FloatingSupport/FloatingSupport";
import AdminUserService from "../../API/Services/AdminService/AdminUserService";

const validateFields = ({ firstName, lastName, company, email, password }) => {
    const errorsObj = {};
    let error = false;

    if (!firstName) {
        errorsObj.firstName = 'First Name is Required';
        error = true;
    }
    if (!lastName) {
        errorsObj.lastName = 'Last Name is Required';
        error = true;
    }
    if (!company) {
        errorsObj.company = 'Company is Required';
        error = true;
    }
    if (!email) {
        errorsObj.email = 'Email is Required';
        error = true;
    }
    else if (!/\S+@\S+\.\S+/.test(email)) {
        errorsObj.email = 'Email format is invalid';
        error = true;
    }
    if (!password) {
        errorsObj.password = 'Password is Required';
        error = true;
    }

    return { errorsObj, error };
};

function Registration() {
    const navigate = useNavigate();
    const [formState, setFormState] = useState({
        firstName: '',
        lastName: '',
        company: '',
        notes: '',
        email: '',
        password: '',
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("usertoken")) {
          navigate("/dashboard");
        } else {
          navigate("/registration");
          localStorage.clear();
        }
      }, []);

    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormState(prevState => ({ ...prevState, [name]: value }));
        setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
        setSuccessMessage('');
        setErrorMessage('');
    }, []);

    const onSignUp = async (e) => {
        e.preventDefault();
        setSuccessMessage('');
        setErrorMessage('');
        setLoading(true);

        const { errorsObj, error } = validateFields(formState);
        setErrors(errorsObj);

        if (error) {
            setLoading(false);
            return;
        }

        const { firstName, lastName, company, notes, email, password } = formState;

        try {
            const response = await AdminUserService.signup(firstName, lastName, company, notes, email, password);
            const data = await response.json();

            if (data.status) {
                setSuccessMessage(data.message || "Registration successful!");
                setTimeout(() => {
                    navigate('/');
                }, 5000);
            } else {
                setErrorMessage(data.message || "Registration failed. Please try again.");
            }
        } catch (error) {
            console.error("Registration API error:", error);
            setErrorMessage("An unexpected error occurred during registration.");
        } finally {
            setLoading(false);
        }
    };

    const { firstName, lastName, company, notes, email, password } = formState;

    return (
        <Fragment>
            <div className="page-wraper">
                <div className="browse-job login-style3">
                    <div className="bg-img-fix overflow-hidden" style={{ background: "#fff url(" + bg6 + ")", height: "100vh" }}>
                        <div className="row gx-0">
                            <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 vh-100 bg-white">
                                <div
                                    id="mCSB_1"
                                    className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                                    style={{ maxHeight: "653px" }}
                                >
                                    <div
                                        id="mCSB_1_container"
                                        className="mCSB_container"
                                        style={{
                                            position: "relative",
                                            top: "0",
                                            left: "0",
                                            dir: "ltr",
                                        }}
                                    >
                                        <div className="login-form style-2">
                                            <div className="card-body">
                                                <div className="logo-header">
                                                    <Link to={"#"} className="logo">
                                                        <img
                                                            src={logo}
                                                            alt=""
                                                            className="width-230 light-logo"
                                                        />
                                                    </Link>
                                                    <Link to={"#"} className="logo">
                                                        <img
                                                            src={LogoWhite}
                                                            alt=""
                                                            className="width-230 dark-logo"
                                                        />
                                                    </Link>
                                                </div>

                                                {(errorMessage || successMessage) && (
                                                    <div className={`alert ${successMessage ? 'alert-success' : 'alert-danger'} text-center mt-3`}>
                                                        {errorMessage || successMessage}
                                                    </div>
                                                )}

                                                <form className="dz-form py-2" onSubmit={onSignUp}>
                                                    <h3 className="form-title">Sign Up</h3>
                                                    <div className="dz-separator-outer m-b5">
                                                        <div className="dz-separator bg-primary style-liner"></div>
                                                    </div>
                                                    <p>Enter your personal details below: </p>

                                                    {/* First Name */}
                                                    <div className="form-group mt-3">
                                                        <input type="text" name="firstName" value={firstName} onChange={handleInputChange} className="form-control" placeholder="First Name" />
                                                        {errors.firstName && <div className="text-danger fs-12">{errors.firstName}</div>}
                                                    </div>

                                                    {/* Last Name */}
                                                    <div className="form-group mt-3">
                                                        <input type="text" name="lastName" value={lastName} onChange={handleInputChange} className="form-control" placeholder="Last Name" />
                                                        {errors.lastName && <div className="text-danger fs-12">{errors.lastName}</div>}
                                                    </div>

                                                    {/* Company */}
                                                    <div className="form-group mt-3">
                                                        <input type="text" name="company" value={company} onChange={handleInputChange} className="form-control" placeholder="Company" />
                                                        {errors.company && <div className="text-danger fs-12">{errors.company}</div>}
                                                    </div>

                                                    {/* Note */}
                                                    <div className="form-group mt-3">
                                                        <input type="text" name="notes" value={notes} onChange={handleInputChange} className="form-control" placeholder="Note" />
                                                    </div>

                                                    {/* Email */}
                                                    <div className="form-group mt-3">
                                                        <input type="email" name="email" value={email} onChange={handleInputChange} className="form-control" placeholder="E-mail" />
                                                        {errors.email && <div className="text-danger fs-12">{errors.email}</div>}
                                                    </div>

                                                    {/* Password */}
                                                    <div className="form-group mt-3">
                                                        <input
                                                            type="password"
                                                            name="password"
                                                            value={password}
                                                            onChange={handleInputChange}
                                                            className="form-control"
                                                            placeholder="Password"
                                                        />
                                                        {errors.password && <div className="text-danger fs-12">{errors.password}</div>}
                                                    </div>

                                                    <div className="form-group clearfix text-left mt-4">
                                                        <NavLink to="/" className="btn btn-primary outline gray" type="button">Back</NavLink>
                                                        <button type="submit" className="btn btn-primary float-end" disabled={loading}>
                                                            {loading ? 'Submitting...' : 'Submit'}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="card-footer">
                                                <div className=" bottom-footer clearfix m-t10 m-b20 row text-center">
                                                    <div className="col-lg-12 text-center">
                                                        <p>
                                                            © {new Date().getFullYear()} Website Developed by{" "}
                                                            <a
                                                                href="https://www.rigicglobalsolutions.com/"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Rigic Global Solutions Pvt Ltd
                                                            </a>{" "}
                                                            All Rights Reserved
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FloatingSupport inline={true} auth={true} />
        </Fragment>
    );
};

export default Registration;
